import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";
import PlayerPaths from "../../constants/paths/playerPaths";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

class Lists extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
		};
	}

	onClickList(e, listIndex) {
		this.props.dispatch(
			playerActions.setSelectedListIndexAndSpeak,
			listIndex
		);
	}

	handleShowReleaseNotes() {
		playerActions.showReleaseNotesModal();
	}

	render() {
		let self = this;

		let lists;

		if (!this.props.activity.hasOwnProperty("firstLevel") || this.props.activity.firstLevel === "lists") {
			lists = self.props.activity.children.map(function (list, i) {

				let completedColor = "#BA282A";
				let completionState = list.completionState;
				if (completionState === "i") {
					completedColor = "#F9A200";
				} else if (completionState === "c") {
					completedColor = "#4f7017";
				}

				let listComponent;
				if (Utils.isVisible(list)) {

					// Don't set fixed height
					let listStyle = { alignItems: "center", borderRightWidth: 1, borderTopWidth: 1, borderColor: "#666666", backgroundColor: "#888888", display: "flex", justifyContent: "center", /*height: 50,*/paddingTop: 15, paddingLeft: 15, paddingRight: 15, paddingBottom: 20 };
					let titleStyles = {
						fontSize: "16px",
						fontWeight: "normal",
						color: "white"
					};
					if (list.resolvedStyles && list.resolvedStyles.list) {
						listStyle = _.assign({}, listStyle, list.resolvedStyles.list);
						listStyle.borderLeftWidth = "0px";
						listStyle.borderTopStyle = listStyle.borderRightStyle = "solid";


						delete listStyle.borderRadius; //remove radius						
					}
					if (list.resolvedStyles && list.resolvedStyles.title) {
						titleStyles = _.assign({}, titleStyles, list.resolvedStyles.title);
					}
					let barHeight = 10;
					if (self.props.selectedListIndex !== i) {
						// listStyle.opacity = .5;
						if (list.hideStatus) {
							barHeight = 0;
						} else {
							barHeight = 6;
						}
					} else {
						titleStyles.fontWeight = "bold";
					}

					let iconComponent = null;
					// Don't hardwire
					// titleStyles.fontSize = "14px";
					if (list.iconFa) {
						listStyle.display = "flex";
						listStyle.flexDirection = "row";
						iconComponent = <FontAwesomeIcon icon={list.iconFa} style={{ color: list.iconColor && !_.isEmpty(list.iconColor) ? list.iconColor : titleStyles.color, fontSize: titleStyles.fontSize, marginRight: 5 }} />;
					}

					listComponent =
						<div style={{ position: "relative", cursor: "pointer" }} key={"list" + i + "session" + self.props.session} onClick={(e) => self.onClickList(e, i)}>
							<div style={listStyle}>
								{iconComponent}<div style={titleStyles}>{Utils.getRealName(list.name)}</div>
							</div>
							{/* <div style={{ position: "absolute", bottom: 0, right: 0, left: 0, height: barHeight, backgroundColor: completedColor, borderRight: "1px solid #666666"}} /> */}
							<div style={{ position: "absolute", bottom: 0, left: 0, width: "100%", height: barHeight, backgroundColor: list.hideStatus ? "rgba(32,32,32,1)" : "#BA282A" }}>
								<div style={{ position: "absolute", bottom: 0, left: 0, width: ((list.progressCount / list.progressTotal) * 100) + "%", height: barHeight, backgroundColor: list.hideStatus ? "rgba(32,32,32,1)" : completedColor }} />
							</div>

						</div>;
				}
				return listComponent;
			});
		}

		if (self.props.releaseNotes && self.props.releaseNotes.content && self.props.releaseNotes.content !== "") {
			return <div style={{ width: "100%", alignItems: "center", justifyContent: "space-between",display:"flex" }}>
				<div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
					{lists}
				</div>
				<div className="btn-related-item" style={{ width: 50, height: 50, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", borderLeftWidth: 1, borderLeftColor: "gray", cursor: "pointer" }} onClick={self.handleShowReleaseNotes}>
					<FontAwesomeIcon icon={"sticky-note"} style={{ color: "white", margin: 5, fontSize: 20 }} />
					<div style={{ color: "white", fontSize: 10 }}>{self.props.releaseNotes.version}</div>
				</div>
			</div>;
		} else {
			return <div style={{ display: "flex", flexDirection: "row", flexShrink: 0 }}>
				{lists}
			</div>;
		}
	}
}

Lists.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	selectedListIndex: PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX,
	activity: PlayerPaths.ACTIVITY,
	releaseNotes: ["releaseNotes"]
}, Lists);